import { StyledSystemProps, Flex } from '@creditas-ui/react';

interface MenuGroupBaseProps {
  children: React.ReactNode;
}

type MenuGroupElProps = React.HTMLAttributes<HTMLDivElement>;

type MenuGroupProps = MenuGroupBaseProps & MenuGroupElProps & StyledSystemProps;

const MenuGroup = ({ children, ...props }: MenuGroupProps): JSX.Element => (
  <Flex {...props} alignItems="center">
    {children}
  </Flex>
);

export { MenuGroup };
